<template>
	<b-container class="no-padding">
		<b-row v-if="error == null">
			<b-col v-if="showSelectFrame == false">
				<b-container class="no-padding">
					<b-row no-gutters>
						<b-col no-gutters>
							<div 	v-on:click="openSelectFrame"
									class="image-preview-frame">
								<div v-if="selectedElementObject == null">
									<div class="add-wrapper"><div class="space20"></div>Bild<br><span class="icon-plus-circled"></span></div>
								</div>		
								<div v-else>
									<div 	v-bind:style="{backgroundImage: 'url(https://res.cloudinary.com/vrnu/image/upload/c_fill,h_96,w_96/v' + selectedElementObject.version + '/' + selectedElementObject.public_id + '.' + selectedElementObject.format + ')'}"
											v-on:click="openSelectFrame"
											class="media-frame-preview">
									</div>
								</div>
							</div>						
						</b-col>
						<b-col cols="9">
							<span v-if="selectedElementObject == null">Bitte wählen Sie ein Bild aus. Klicken Sie dazu auf die Vorschau-Box.</span>
							<span v-else>Sie haben ein Bild ausgewählt. Zum Ändern klicken Sie auf die Vorschau-Box.</span>
							<span>Um Bilder hochzuladen, navigieren Sie bitte zu <router-link to="/media">Medien</router-link>.</span>						
						</b-col>
					</b-row>
				</b-container>
			</b-col>
			<b-col v-else>
				<div class="image-select-frame">
					<div 	v-for="(mediaElement, index) in mediaElements"
							v-bind:index="index"
							v-bind:id="mediaElement._id"
							v-bind:style="{backgroundImage: 'url(https://res.cloudinary.com/vrnu/image/upload/c_fill,h_96,w_96/v' + mediaElement.version + '/' + mediaElement.public_id + '.' + mediaElement.format + ')'}"
							v-on:click="elementSelected(mediaElement._id)"
							class="media-frame">
					</div>
					<div 	v-on:click="getImages"
							class="media-frame refresh-frame">
						<span class="icon-ccw refresh-icon"></span>
					</div>
				</div>
			</b-col>
		</b-row>	
		<b-row v-else>
			<b-col>
				<b-alert variant="danger">{{ error }}</b-alert>
			</b-col>
		</b-row>	
	</b-container>
</template>

<script>
export default {
	data: function() {
		return {
			error: null,
			showSelectFrame: false,
			mediaElements: [],
			selectedElement: null,
			selectedElementObject: null,
		};
	},
	methods: {
		emitImage: function() {
			// Send the selected image to the parent element
			this.$emit('input', this.selectedElement);
		},
		getImages: function() {
			// Get images from server
			this.$http.get('upload/image').then(images => {
				this.mediaElements = images.body;
			}, response => {
				this.error = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		getImage: function(id) {
			// Get image from server
			this.$http.get('upload/image/' + id).then(image => {
				this.selectedElementObject = image.body;
			}, response => {
				this.error = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});			
		},
		elementSelected: function(id) {
			this.selectedElement = id;
			this.getImage(id);
			this.emitImage();
			this.closeSelectFrame();
		},
		openSelectFrame: function() {
			this.showSelectFrame = true;
		},
		closeSelectFrame: function() {
			this.showSelectFrame = false;
		},
	},
	watch: {
		selectedElement: function() {
 			if(this.selectedElement !== null) {
				this.getImage(this.selectedElement);	
			}
		},
		value: function() {
			// Check if a value was passed
			if(this.value !== null) {
				this.selectedElement = this.value;
				this.emitImage();
			}			
		},
	},
	created: function() {
		// Get all images from server
		this.getImages();
	},
	props: {
		value: {
			default: null,
		},
	},
}
</script>

<style scoped>
.image-preview-frame {
	width: 100px;
	height: 100px;
	padding: 3px;
	
	color: #495047;
	
	border: 1px dashed #ced4da;
	border-radius: 0.25rem;
	
	cursor: pointer;
}
.image-select-frame {
	max-height: 215px;	
	overflow-y: auto;
	
	color: #495047;
	
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
}
.media-frame {
	display: inline-block;
	
	width: 88px;
	height: 88px;
	
	margin: 6px 0px 0px 6px;
}
.media-frame:HOVER {
	cursor: pointer;
	
	-webkit-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	-moz-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
}
.media-frame-preview {
	display: inline-block;
	
	width: 88px;
	height: 88px;
	
	margin: 2px 0px 0px 2px;
}
.refresh-frame {
	position: relative;
	
	border: 1px dashed #ced4da;
	border-radius: 0.25rem;
}
.refresh-icon {
	position: absolute;
	top: 12px;
	margin-left: 20px;
	
	font-size: 40px;
	color: #000000;
}
.add-wrapper {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/98_ui/ImageSelector.vue